<template>
  <button
    type="button"
    class="relative inline-flex h-10 w-10 before:absolute before:-inset-0.5 before:content-[''] items-center justify-center rounded-md transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-cyan-300 focus-visible:ring-offset-2 focus-visible:ring-offset-transparent"
    :class="toneClass"
    @click="switchTheme"
    :aria-label="isDark ? 'Switch to light mode' : 'Switch to dark mode'"
  >
    <!-- Icons follow html.dark (set before the first paint), not isDark, so the server-rendered
         button already shows the sun on a dark-theme visit. -->
    <IconMoon class="h-5 w-5 dark:hidden" />
    <IconSun class="hidden h-5 w-5 dark:block" />
  </button>
</template>

<script setup>
const props = defineProps({
  tone: {
    type: String,
    default: "dark",
  },
});

const colorMode = useColorMode();
const isMounted = ref(false);
const isDark = computed(() => isMounted.value && colorMode.value === "dark");

const toneClass = computed(() =>
  props.tone === "light"
    ? "text-slate-600 hover:bg-slate-100 hover:text-slate-950 dark:text-slate-300"
    : "text-slate-300 hover:bg-white/10 hover:text-white",
);

const switchTheme = () => {
  colorMode.preference = isDark.value ? "light" : "dark";
};

onMounted(() => {
  isMounted.value = true;
});
</script>
